import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI } from 'store/apiReducer';
import { SelectMi, Option } from '@design-system-etat/dsfr-react';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER,
    CONTEXT_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER,
} from '../../../../constants/apiUrls.constants';

const SelectQuestionsCompteUsager = ({
    referentielQuestionsCompteUsager,
    getApi,
    name,
    label,
    texteAide,
    displayRequired,
    error,
    warning,
    valid,
    disabled,
    required,
    onChange,
    register,
}) => {
    const getQuestionsCompteUsager = () => {
        getApi(
            usagerClientReducer,
            API_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER,
            CONTEXT_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER,
        );
    };

    useEffect(() => {
        if (
            !referentielQuestionsCompteUsager ||
            Object.keys(referentielQuestionsCompteUsager).length === 0
        ) {
            getQuestionsCompteUsager();
        }
    }, [referentielQuestionsCompteUsager]);

    const getOptions = () => {
        if (referentielQuestionsCompteUsager) {
            return referentielQuestionsCompteUsager.map((element) => {
                return {
                    key: element.questionCompteUsager,
                    value: element.questionCompteUsager,
                    libelle: element.questionCompteUsager,
                };
            });
        }
        return [];
    };

    return (
        <SelectMi
            name={name}
            label={label}
            texteAide={texteAide}
            placeholder={referentielQuestionsCompteUsager ? ' ' : 'Chargement en cours...'}
            displayRequired={displayRequired}
            error={error}
            warning={warning}
            valid={valid}
            disabled={disabled}
            required={required}
            onChange={onChange}
            {...register}
        >
            {getOptions().map((option) => {
                return (
                    <Option key={option.key} value={option.value}>
                        {option.libelle}
                    </Option>
                );
            })}
        </SelectMi>
    );
};

SelectQuestionsCompteUsager.propTypes = {
    name: PropTypes.string.isRequired,
    referentielQuestionsCompteUsager: PropTypes.array,
    getApi: PropTypes.func.isRequired,
    label: PropTypes.string,
    texteAide: PropTypes.string,
    displayRequired: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    /** Fonction register de React Hook Form */
    register: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        ref: PropTypes.any.isRequired,
    }),
    onChange: PropTypes.func,
    error: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
    warning: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
    valid: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
};

SelectQuestionsCompteUsager.defaultProps = {
    label: null,
    displayRequired: false,
    disabled: false,
    required: false,
    texteAide: null,
    onChange: null,
};

export default connect(
    (state) => {
        const { isLoading, erreur, data, message } = state.referentiel.questionsCompteUsager;
        return {
            isLoading,
            erreur,
            referentielQuestionsCompteUsager: data,
            message,
        };
    },
    {
        getApi: getAPI,
    },
)(SelectQuestionsCompteUsager);
